var ValueJS = ValueJS || {};

ValueJS.LazyLoad = function() {

    var _contentLoader;
    var _backgroundLoader;

    var _initialized = false;

    var _init = function() {
        if (!_initialized) {

            // initialize lazy loader for content elements
            _contentLoader = new LazyLoad({
                use_native: true,
                elements_selector: ".lazy"
            });

            // initialize lazy loader for background elements
            _backgroundLoader = new LazyLoad({
                elements_selector: ".bg-lazy"
            });

            // reload if section is reloaded in shopify theme editor
            _handleShopifyDesignModeEvents();

            _initialized = true;
        }
    }

    var _handleShopifyDesignModeEvents = function() {
        if (Shopify.designMode) {

            $(document).on('shopify:section:load', function(e) {
                _update();
            });

            $(document).on('shopify:section:unload', function(e) {
                _update();
            });

            $(document).on('shopify:section:select', function(e) {
                _update();
            });

            $(document).on('shopify:section:deselect', function(e) {
                _update();
            });

            $(document).on('shopify:block:select', function(e) {
                _update();
            });

            $(document).on('shopify:block:deselect', function(e) {
                _update();
            });

        }
    }

    var _update = function() {
        if (_initialized) {
            _contentLoader.update();
            _backgroundLoader.update();
        }
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        update : function() {return _update();},
    };

}();

$(function() {
    ValueJS.LazyLoad.init();
});
